
        var result = require("!!../../../../node_modules/css-loader/index.js!./customer-overview.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/customers/customer-overview/customer-overview.component.css
// module id = 2495
// module chunks = 1